module.exports = __webpack_public_path__ + "img/discord-logo.cc8afd29.svg";